import { FC } from 'react';
import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { theme } from '../styles/GlobalStyles';
import { heroSlides } from '../data/heroSlides';


const HeroSection = styled.section`
  padding: 0;
  margin-bottom: 2rem;
`;

const StyledCarousel = styled(Carousel)`
  .carousel .slide {
    background: none;
  }

  .carousel .slide img {
    max-height: 80vh;
    object-fit: cover;

    @media (max-width: ${theme.breakpoints.mobile}) {
      max-height: 50vh;
    }
  }

  .carousel .control-dots {
    margin-bottom: 1.5rem;
  }

  .carousel .control-dots .dot {
    background: ${theme.primaryDark};
    box-shadow: none;
    width: 10px;
    height: 10px;
  }

  .carousel .control-arrow {
    opacity: 0.8;
    
    &:hover {
      opacity: 1;
    }
  }

  .legend {
    background: rgba(0, 0, 0, 0.6);
    border-radius: 0;
    font-size: 1.2rem;
    opacity: 0.9;
    width: 100%;
    margin-left: 0;
    left: 0;
    bottom: 0;
    padding: 15px;
    
    @media (max-width: ${theme.breakpoints.tablet}) {
      font-size: 1rem;
      padding: 10px;
    }
  }
`;

const Hero: FC = () => {
  return (
    <HeroSection>
      <StyledCarousel
        showArrows={true}
        showStatus={false}
        showThumbs={false}
        infiniteLoop={true}
        autoPlay={true}
        interval={5000}
        stopOnHover={true}
        emulateTouch={true}
        ariaLabel="Tuotekuvat"
      >
        {heroSlides.map((slide, index) => (
          <div key={slide.id}>
            <img src={slide.src} alt={slide.alt} fetchPriority={index === 0 ? 'high' : 'auto'} />
            <p className="legend">{slide.legend}</p>
          </div>
        ))}
      </StyledCarousel>
    </HeroSection>
  );
};

export default Hero; 